import React from 'react';
import { Flex } from 'components/base/layout-components';
import { TitleWithGraphIcon } from 'components/TitleWithIcons';
import ClickableDeploymentPipeline from './ClickableDeploymentPipeline';
import CycleTimeTrendPopper from './CycleTimeTrendPopper';
import * as TrackingService from 'common/services/tracking.service';
import {
  MEDIAN_VALUES,
  metricNames,
  METRICS_CALCULATION_STRATEGY_LABEL
} from '@linearb/linjs-common';
import { useSelector } from 'react-redux';
import { isIterationsPeriodKeySelectedSelector } from 'state/selectors/ui-state';
import { activeGithubCloudIntegrationsSelector } from 'state/selectors/sensors-authorizations';
import { ARTICLE_IDS, TRACKING } from 'common/constants/constants';

import MetricsBenchmarkIcon from 'components/MetricsBenchmarkIcon';
import Text from 'components/base/Text';
import { Link } from '@material-ui/core';
import * as LighthouseService from 'common/services/lighthouse.service';
import useMetricsCalculationConfig from '../../../../hooks/useMetricsCalculationConfig';
import size from 'lodash/size';
import { CycleTimeSkeleton } from '@linearb/linui-common';
import WidgetDescription from '../../../performance/views/CustomReport/Widgets/CustomWidget/Header/WidgetDescription';
import { capitalize } from 'lodash';
import { getIsBenchmarkPending } from './CycleTime.utils';

const CycleTime = ({
  onLinkIconClick,
  avgTime,
  configurations,
  trendData,
  dates,
  toggleModal,
  value,
  selectedTeamId,
  isLodingCycleTimeData,
  hideTrendData = false
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = event => {
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.DASHBOARD,
      click_type: TRACKING.CLICK.CYCLE_TIME_TREND
    });
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const isIterationsPeriodKeySelected = useSelector(
    isIterationsPeriodKeySelectedSelector
  );
  const isShowGitStreamCTA =
    size(useSelector(activeGithubCloudIntegrationsSelector)) > 0;

  const isBenchmarkPending = getIsBenchmarkPending({ configurations });

  const avgTimeStrWithPendingStatus = `${avgTime} ${
    isBenchmarkPending ? ' * ' : ''
  }`;

  const { metricsCalculationStrategy } = useMetricsCalculationConfig();

  const showTrendsChart = isIterationsPeriodKeySelected && !hideTrendData;

  const dataCyPrefix = 'dashboard-cycle-time';

  return (
    <Flex direction='column' width='100%' pb='small' pr='medium' pl='medium'>
      <TitleWithGraphIcon
        onLinkIconClick={onLinkIconClick}
        onClick={handleClick}
        isOpen={!!anchorEl}
        articleId={ARTICLE_IDS.CYCLE_TIME}
        title='Cycle Time'
        mb='small'
        additionalIcons={[]}
        toggleModal={toggleModal}
        expandChartTooltip={'Cycle time iteration trend'}
        showTrends={showTrendsChart}
      />
      {isLodingCycleTimeData ? (
        <CycleTimeSkeleton />
      ) : (
        <>
          {' '}
          <Flex items='center' mb='x-small' height='5rem'>
            {!isBenchmarkPending && (
              <MetricsBenchmarkIcon
                value={value}
                metricName={metricNames.CYCLE_TIME}
                size='large'
                margin='0 0.5rem 0 0'
                selectedTeamId={selectedTeamId}
                isBenchmarkPending={isBenchmarkPending}
                popperPlacement='bottom-start'
              />
            )}
            <WidgetDescription
              formattedAverage={avgTimeStrWithPendingStatus}
              formattedDescription={`${capitalize(
                METRICS_CALCULATION_STRATEGY_LABEL[metricsCalculationStrategy]
              )} Cycle Time`}
              dataCyPrefix={dataCyPrefix}
            />
          </Flex>
          <Flex height='2.5rem' color='shuttleGray'>
            {isBenchmarkPending ||
              (metricsCalculationStrategy === MEDIAN_VALUES.p50 && (
                <Text size='medium'>
                  * not showing benchmarks{' '}
                  <Link
                    onClick={() =>
                      LighthouseService.navigateArticle(ARTICLE_IDS.CYCLE_TIME)
                    }
                  >
                    learn more
                  </Link>
                </Text>
              ))}
          </Flex>
          <ClickableDeploymentPipeline
            configurations={configurations}
            dates={dates}
            enableDescription={false}
            isShowGitStreamCTA={isShowGitStreamCTA}
            dataCyPrefix={dataCyPrefix}
          />
          <CycleTimeTrendPopper
            anchorEl={anchorEl}
            data={trendData}
            onClose={() => setAnchorEl(null)}
          />
        </>
      )}
    </Flex>
  );
};

export default CycleTime;
